import "../scss/style.scss";
import "scroll-hint/css/scroll-hint.css";
import "./anime.js"
import "./splide_setting.js"
import "./splide-extension-auto-scroll.js"
import "./index.js"
import "./dropdown.js"
